module.exports = __webpack_public_path__ + "034.78c93f5c.png";